<template>
  <el-dialog
    v-model="dialogFormVisible"
    :title="title"
    width="500px"
    @close="close"
  >
    <el-form ref="form" label-width="80px" :model="form" :rules="rules">
      <el-form-item label="标题" prop="title">
        <el-input v-model.trim="form.title" />
      </el-form-item>
      <el-form-item label="备注" prop="text">
        <el-input v-model.trim="form.text" />
      </el-form-item>
      <el-form-item label="排序" prop="order">
        <el-input-number v-model="form.order" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { addIndustry, editIndustry } from '@/api/branch'

  export default {
    name: 'BranchBranchEdit',
    emits: ['fetch-data'],
    data() {
      return {
        form: {
          title: '',
          text: '',
          order: '',
        },
        rules: {
          title: [{ required: true, trigger: 'blur', message: '请填写标题' }],
          text: [],
        },
        title: '',
        dialogFormVisible: false,
      }
    },
    methods: {
      showEdit(row) {
        if(!row){
          this.title = '新增业态'
        }else{
          this.title = '修改业态'
          this.form = Object.assign(
            {},
            {
              industryId: row.industryId,
              title: row.title,
              text: row.basic.text,
              order: row.basic.order,
            }
          )
        }
        this.dialogFormVisible = true
      },
      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            await this.form.industryId ? editIndustry(this.form) : addIndustry(this.form)
            this.$baseMessage(
              this.form.industryId ? '修改业态成功' : '新增业态成功',
              'success',
              false,
              'vab-hey-message-success'
            )
            this.$emit('fetch-data')
            this.close()
          } else {
            return false
          }
        })
      },
    },
  }
</script>
